import type { TFunction } from 'i18next';
import { FormItem } from '@ohpen/enso-ui';
import { DEFAULT_TEXT_MAX_LENGTH_SHORT, textLimitProps } from '@pmp/utils';

type SelectOption = { label: string; value: string };
type RenderItem = FormItem['renderFormItem'];

const labels = 'lender.regionsBdms.labels';

type RegionSchemaRenderers = { warning?: RenderItem; linkedBdms?: RenderItem };

export const getRegionSchema = (t: TFunction, render: RegionSchemaRenderers = {}): FormItem[] => [
  ...(render.warning ? [{ renderFormItem: render.warning }] : []),
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.nameRequired`) }],
    },
    fieldProps: textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
  },
  ...(render.linkedBdms ? [{ title: `${labels}.linkedBdms`, renderFormItem: render.linkedBdms }] : []),
];

type BdmSchemaRenderers = { hint?: RenderItem; warning?: RenderItem; assignedTradingAddresses?: RenderItem };

export const getBdmSchema = (t: TFunction, regionOptions: SelectOption[], render: BdmSchemaRenderers = {}): FormItem[] => [
  ...(render.warning ? [{ renderFormItem: render.warning }] : []),
  ...(render.hint ? [{ renderFormItem: render.hint }] : []),
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.nameRequired`) }],
    },
    fieldProps: textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
  },
  {
    title: `${labels}.contactNumber`,
    dataIndex: 'contactNumber',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.contactNumberRequired`) }],
    },
    fieldProps: textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
  },
  {
    title: `${labels}.description`,
    dataIndex: 'description',
    valueType: 'textarea',
    fieldProps: textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
  },
  {
    title: `${labels}.linkedRegions`,
    dataIndex: 'regionIds',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true, type: 'array', min: 1, message: t(`${labels}.linkedRegionsRequired`) }],
    },
    fieldProps: { mode: 'multiple', options: regionOptions, optionFilterProp: 'label', allowClear: true },
  },
  ...(render.assignedTradingAddresses
    ? [{ title: `${labels}.assignedTradingAddresses`, renderFormItem: render.assignedTradingAddresses }]
    : []),
];

export const getReplaceSchema = (
  titleKey: string,
  requiredMessage: string,
  options: SelectOption[],
  renderExplanation?: RenderItem,
): FormItem[] => [
  ...(renderExplanation ? [{ renderFormItem: renderExplanation }] : []),
  {
    title: titleKey,
    dataIndex: 'replacementId',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true, message: requiredMessage }],
    },
    fieldProps: { options, optionFilterProp: 'label', showSearch: true },
  },
];
